import React, { Component } from 'react';

import parseQueryString from '../../utils/parseQueryString';
import toQueryString from '../../utils/toQueryString';
import api from '../../utils/api';

import FormLoadingSkeleton from './../../Components/LoadingSkeletons/FormLoadingSkeleton';

import AdvertiseTwoFactorAuth from './Screens/AdvertiseTwoFactorAuth';
import PasswordUpdateNeeded from './Screens/PasswordUpdateNeeded';
import PasswordUpdateEidi from './Screens/PasswordUpdateEidi';
import BouncedEmailInfo from './Screens/BouncedEmailInfo';

const POST_LOGIN_REASONS = [
  'manual',
  'eidi',
  'old_version',
  'long_inactive',
  'email_bounced',
  'no_two_factor_auth',
];

class PostLoginContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: null,
      reason: null,
    };

    this.toLogin = this.toLogin.bind(this);
    this.reasonToComponent = this.reasonToComponent.bind(this);
  }

  toLogin() {
    const queryObject = parseQueryString(this.props.location.search);
    const queryString = toQueryString(queryObject);
    const redirectUrl = '/' + (queryString === '' ? '' : `?${queryString}`);
    this.props.history.replace(redirectUrl);
  }

  componentDidMount() {
    api
      .get('/login/post_login')
      .then(({ reason, email }) => {
        if (POST_LOGIN_REASONS.includes(reason)) {
          this.setState({
            reason,
            email,
          });
        } else {
          this.toLogin();
        }
      })
      .catch(err => {
        if (err.response) {
          const { status } = err.response;
          // bad request is thrown when the user is already logged in and is caught in api.js
          // everything else should just redirect to the login form
          if (status && status !== 400) this.toLogin();
          if (!status) this.toLogin();
        }
      });
  }

  reasonToComponent() {
    const { reason } = this.state;

    if (['manual', 'old_version', 'long_inactive'].includes(reason)) {
      return PasswordUpdateNeeded;
    }
    if (reason === 'eidi') return PasswordUpdateEidi;
    if (reason === 'email_bounced') return BouncedEmailInfo;
    if (reason === 'no_two_factor_auth') return AdvertiseTwoFactorAuth;

    return FormLoadingSkeleton;
  }

  render() {
    const { email } = this.state;

    const Component = this.reasonToComponent();

    return <Component email={email} toLogin={this.toLogin} />;
  }
}

export default PostLoginContainer;
